import { render, staticRenderFns } from "./InfoTsel.vue?vue&type=template&id=1a66267a&scoped=true"
import script from "./InfoTsel.vue?vue&type=script&lang=js"
export * from "./InfoTsel.vue?vue&type=script&lang=js"
import style1 from "./InfoTsel.vue?vue&type=style&index=1&id=1a66267a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a66267a",
  null
  
)

export default component.exports